/**
 * MegamenuButtonsMaxWidth Class
 */
export class MegamenuButtonsMaxWidth {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.allBlocks = document.querySelectorAll( containerEl );
		if ( ! this.allBlocks || this.allBlocks.length === 0 ) {

			return false;

		}

		this.init();

	}

	/**
	 * Init
	 *
	 * @return {void}
	 */
	init() {

		if ( this.allBlocks.length > 0 ) {

			this.allBlocks.forEach( ( block ) => {

				const gap = 34;
				const blockWidth = block.offsetWidth;
				const logo = block.querySelector( '.wp-block-site-logo' );
				const items = block.querySelectorAll( '.b-megamenu-item' );

				const extras = block.querySelector( '.b-megamenu-extras' );

				const allItemsWidth = Array.from( items ).reduce( ( total, item ) => total + item.offsetWidth, gap ) + ( logo ? logo.offsetWidth : 0 );

				if ( extras && extras.offsetWidth > ( blockWidth - allItemsWidth ) ) {

					setTimeout( () => {

						extras.classList.add( 'is-wider' );

					}, 1000 );

				}

			} );

		}

	}

}
